exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-v-377ee154]{align-items:center}.container[data-v-377ee154]{display:flex;flex-direction:row;justify-content:center;user-select:none}.board[data-v-377ee154]{display:flex;flex-flow:row wrap;height:630px;width:630px}.info[data-v-377ee154]{width:200px;margin-left:50px;padding-top:25px}.time[data-v-377ee154]{font-size:2em;margin-bottom:50px}.hint[data-v-377ee154],.step[data-v-377ee154]{margin-bottom:50px}.description[data-v-377ee154]{line-height:1.5;color:#9e9e9e}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-377ee154","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Game.vue
// module id = 34
// module chunks = 0